// @context TGW-2694 events_plans.description は varchar(191)。入力欄に上限が無く、イベント本文が
//   まるごと貼られて1文字ごとの自動保存が ValueTooLong で500になり続けた（本番で1秒に8件の通知）。
//   画面には何も出ないので、主催者は保存できていると思い込んでいた。
//   入力欄の maxLength で止め、上限に達したら赤文字で知らせる。maxLength は日本語入力の確定前に
//   すり抜けるブラウザがあるので、自動保存の直前でも超えていれば送らない。
//   schema.rb は limit 無しの t.string なので 255 に見えるが、config/initializers/mysqlpls.rb で
//   string の既定が 191 になっている（utf8mb4 対応）。255 にすると 192〜255 文字が500のまま残る。
//   長さは maxLength と同じ数え方（UTF-16 単位）。絵文字は2と数えるので DB（文字数）より厳しい側に倒れる。
export const PLAN_DESCRIPTION_MAX_LENGTH = 191;

export const isPlanDescriptionAtLimit = (description) =>
  (description || '').length >= PLAN_DESCRIPTION_MAX_LENGTH;

export const isPlanDescriptionTooLong = (description) =>
  (description || '').length > PLAN_DESCRIPTION_MAX_LENGTH;
